<div
  class="relative h-12 w-12 flex justify-center items-center text-center p-4 border-2 border-primary-blue rounded-full"
>
  <p class="font-semibold text-primary-blue uppercase">
    {{ abbreviatedName }}
  </p>
</div>
